<script>
import PortalService from "@/api-services/portal.service";

export default {
  name: "employeeAccount",
  components: {},
  props: [],
  data: function () {
    return {
      employeeAdAccounts: [],
      employeeLocalAccounts: [],
      password: null,
      selectedAdAccount: null,
      closeOnContentClick: false,
    };
  },
  methods: {
    getEmployeeAdAccounts: async function () {
      this.tableLoading = true;
      PortalService.getEmployeeAdAccounts()
        .then((response) => {
          this.employeeAdAccounts = response.data.requestResult;
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.$store.commit("setJwt", null);
              this.$store.commit("setIsAuthentified", false);
              this.$router.push("/");
            } else {
              this.$store.commit(
                "setNewErrorMessage",
                error.response.data.requestResult
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
          console.log(error.response.data);
        });
    },
    getEmployeeLocalAccounts: async function () {
      this.tableLoading = true;
      PortalService.getEmployeeLocalAccounts()
        .then((response) => {
          this.employeeLocalAccounts = response.data.requestResult;
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.$store.commit("setJwt", null);
              this.$store.commit("setIsAuthentified", false);
              this.$router.push("/");
            } else {
              this.$store.commit(
                "setNewErrorMessage",
                error.response.data.requestResult
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
          console.log(error.response.data);
        });
    },
    getEmployeeLocalAccountPassword: async function (username) {
      this.tableLoading = true;
      PortalService.getEmployeeLocalAccountPassword(username)
        .then((response) => {
          this.password = response.data.requestResult.password;
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.$store.commit("setJwt", null);
              this.$store.commit("setIsAuthentified", false);
              this.$router.push("/");
            } else {
              this.$store.commit(
                "setNewErrorMessage",
                error.response.data.requestResult
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
          console.log(error.response.data);
        });
    },
  },
  computed: {},
  created() {
    if (this.$store.state.isAuthentified) {
      this.getEmployeeAdAccounts();
      this.getEmployeeLocalAccounts();
    }
  },
};
</script>

<template>
  <div id="employeeAccount">
    <v-card flat>
      <v-card-text
        v-if="employeeLocalAccounts.length > 1"
        class="text-button font-weight-black pb-0 text-center"
        >Comptes locaux
        <v-divider />
      </v-card-text>
      <v-card-text v-else class="text-button font-weight-black pb-0 text-center"
        >Compte local
        <v-divider />
      </v-card-text>
      <v-list dense class="overflow-y-auto">
        <v-list-item-content color="primary">
          <v-list-item
            v-for="localAccount in employeeLocalAccounts"
            :key="localAccount.username"
          >
            <v-list-item-content>
              <v-list-item-title>{{ localAccount.username }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-row>
                <v-menu
                  offset-y
                  left
                  :close-on-content-click="closeOnContentClick"
                  min-width="420px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      plain
                      tile
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        getEmployeeLocalAccountPassword(localAccount.username)
                      "
                    >
                      <v-icon>mdi-lastpass</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-row>
                        <v-col cols="12" sm="7" md="7" class="pa-0">
                          <v-card-text class="overline text-right"
                            >Mot de passe temporaire</v-card-text
                          >
                        </v-col>
                        <v-col
                          style="align-self: center"
                          cols="12"
                          sm="5"
                          md="5"
                          class="pa-0"
                        >
                          <v-card-text class="text-center">{{
                            password
                          }}</v-card-text>
                        </v-col>
                        <v-col
                          style="align-self: center"
                          cols="12"
                          sm="1"
                          md="1"
                          class="pa-0"
                        >
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-content>
      </v-list>
    </v-card>

    <v-card flat>
      <v-card-text
        v-if="employeeAdAccounts.length > 1"
        class="text-button font-weight-black pb-0 text-center"
        >Comptes Réseaux
        <v-divider />
      </v-card-text>
      <v-card-text v-else class="text-button font-weight-black pb-0 text-center"
        >Compte réseau
        <v-divider />
      </v-card-text>
      <v-list dense class="overflow-y-auto">
        <v-list-item-content color="primary">
          <v-list-item
            v-for="adAccount in employeeAdAccounts"
            :key="adAccount.sid"
          >
            <v-list-item-content>
              <v-list-item-title
                >{{ adAccount.domainName }}\{{
                  adAccount.username
                }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action> </v-list-item-action>
          </v-list-item>
        </v-list-item-content>
      </v-list>
    </v-card>
  </div>
</template>
